<template>
    <div  class="tab-navigation w-screen overflow-auto md:overflow-hidden             md:w-full  md:h-screen flex md:flex-column justify-content-between">
        <div class="flex  md:flex-column justify-content-around  md:justify-content-between w-screen md:w-full">
            <div  v-for="item in navItems" :key="item.label" class="tab-item hover:surface-ground" :class="[isActive(item.to) ? 'text-primary border-top-3 md:border-left-3 md:border-top-none border-primary text-primary  ' : 'text-color']"
                @click="navigate(item.to)">
                <div  class="flex cursor-pointer pl-3 pr-3         flex-column justify-content-center align-items-center pt-3 pb-3" >
                    <i  :class="item.icon, [isActive(item.to) ? 'text-primary' : 'text-color']"></i>
                    <span class="text-xs mt-1 " :class="[isActive(item.to) ? 'text-primary' : 'text-color']">{{ item.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';



const props = defineProps({
    items: Array
});

const router = useRouter();
const route = useRoute();


const navItems = computed(() => props.items);


const navigate = (path) => {
    router.push(path);
};

const isActive = (path) => {
    return route.path === path;
};
</script>
<style scoped>
  
</style>

